import { Component, OnInit, Input, SimpleChange } from '@angular/core';
import { CuestionarioService } from '../_services/cuestionario.service';

@Component({
  selector: 'modalevidenciainfo',
  templateUrl: './modalevidenciainfo.component.html'
})
export class ModalevidenciainfoComponent implements OnInit {

  @Input() _id_evidencia: number;

  id_evidencia: number;
  evidencia:any;
  evidenciasfijas: boolean = false;

  constructor( private cuestionarioService: CuestionarioService) { }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['_id_evidencia']){
      this.id_evidencia = changes['_id_evidencia'].currentValue;
    }

  }



  ngOnInit() {

    this.getEvidenciaInfo(this.id_evidencia)
  }


  getEvidenciaInfo(id_evidencia){
    
    this.cuestionarioService.getEvidenciaInfo(id_evidencia).subscribe(
      data => {
        this.evidencia = data.json().evidencia;
        console.log(this.evidencia);
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/cuestionario/modalevidenciainfo.component.ts